import { Base } from 'components/Containers/BaseContainer';
import { ToolbarContainer } from 'components/Containers/ToolbarContainer';
import SWTab from 'components/Layout/Tabs/SWTab';
import { TabList, TabPanel, Tabs } from 'react-tabs';
import { TagAssetMakeModelView } from './TagManagementView/TagManagementView';
import { useAppSelector } from 'store/hook';
import { isDarkTheme } from 'utils/theme';
import { useTranslation } from 'react-i18next';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

export const TagView = () => {
  const { t } = useTranslation();
  const theme = useAppSelector((state) => state.authReducer).customer.theme;
  const enableDarkTheme = isDarkTheme(theme);
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  return (
    <Base enableDarkTheme={enableDarkTheme}>
      <Tabs>
        <TabList style={{ borderBottomColor: palette.primary }}>
          <ToolbarContainer
            style={{
              paddingBottom: 0,
            }}
            enableDarkTheme={enableDarkTheme}
          >
            {/* BUG: The Permission tag causes MUI to detect the SWTab and create empty tab indexes */}
            <SWTab enableDarkTheme={enableDarkTheme}>
              {t('asset_make_model')}
            </SWTab>
          </ToolbarContainer>
        </TabList>

        <TabPanel
          style={{
            padding: '11px 21px 21px',
          }}
        >
          <TagAssetMakeModelView enableDarkTheme={enableDarkTheme} />
        </TabPanel>
      </Tabs>
    </Base>
  );
};
